import config from 'config';
import { http_client } from './api';

const getList = async (page = null, perPage = null, sort = null, orderBy = null, search = null, status = null) => {
  return http_client
    .get(
      config.apiUrl +
        'pembayaran?' +
        `${status ? 'perPage=' + status : ''}` +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const getListArchive = async (page = null, perPage = null, sort = null, orderBy = null, search = null, status = null) => {
  return http_client
    .get(
      config.apiUrl +
        'pembayaran/archive?' +
        `${status ? 'perPage=' + status : ''}` +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'pembayaran', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'pembayaran/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'pembayaran/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'pembayaran/' + id).then((response) => {
    return response.data;
  });
};

const changePaymentStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'pembayaran/status/' + id, data).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'pembayaran/data/status/' + id, data).then((response) => {
    return response.data;
  });
};

const addDiscount = async (data) => {
  return http_client.post(config.apiUrl + 'pembayaran/discount', data).then((response) => {
    return response.data;
  });
};

const deleteDiscount = async (id) => {
  return http_client.post(config.apiUrl + 'pembayaran/discount/' + id).then((response) => {
    return response.data;
  });
};

const addCharges = async (data) => {
  return http_client.post(config.apiUrl + 'pembayaran/charges', data).then((response) => {
    return response.data;
  });
};

const deleteCharges = async (id) => {
  return http_client.post(config.apiUrl + 'pembayaran/charges/' + id).then((response) => {
    return response.data;
  });
};

const addFile = async (id, data) => {
  return http_client.post(config.apiUrl + 'pembayaran/' + id + '/files', data).then((response) => {
    return response.data;
  });
};

const deleteFile = async (id, fileID) => {
  return http_client.delete(config.apiUrl + 'pembayaran/' + id + '/files/' + fileID).then((response) => {
    return response.data;
  });
};

const sendWhatsAppNotification = async (id) => {
  return http_client.get(config.apiUrl + 'pembayaran/' + id + '/whatsapp').then((response) => {
    return response.data;
  });
};

const updatePaymentPeriods = async (id, data) => {
  return http_client.post(config.apiUrl + 'pembayaran/periods/' + id, data).then((response) => {
    return response.data;
  });
};

const ajukanPayment = async (id) => {
  return http_client.post(config.apiUrl + 'pembayaran/ajukan/' + id).then((response) => {
    return response.data;
  });
};

const batalAjukanPayment = async (id) => {
  return http_client.post(config.apiUrl + 'pembayaran/batal-ajukan/' + id).then((response) => {
    return response.data;
  });
};

const PaymentService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changePaymentStatus,
  changeStatus,
  addDiscount,
  deleteDiscount,
  addCharges,
  deleteCharges,
  addFile,
  deleteFile,
  sendWhatsAppNotification,
  updatePaymentPeriods,
  ajukanPayment,
  batalAjukanPayment
};

export default PaymentService;
